import { GlobalContextProps } from '@interfaces/Contexts';
import React from 'react';

export const GlobalContext = React.
    createContext<GlobalContextProps>({} as GlobalContextProps);
